"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  Spinner: true
};
exports.default = exports.Spinner = void 0;
var _reactDom = _interopRequireDefault(require("react-dom"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _react = _interopRequireWildcard(require("react"));
var _focusManager = require("../utils/focusManager");
var _useAnnouncedMessage = require("../utils/_useAnnouncedMessage");
var _useUniqueId = _interopRequireDefault(require("../utils/useUniqueId"));
var _Spinner = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Spinner.css") : void 0);
var _Spinner2 = require("./Spinner.types");
Object.keys(_Spinner2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Spinner2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Spinner2[key];
    }
  });
});
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const CSS_BLOCK = 'sapcnqr-spinner';
const WHEEL_CSS_ELEMENT = `${CSS_BLOCK}__wheel`;
/**
 * The **Spinner** component provides feedback to a user during the loading of
 * another component or page.
 *
 * In order for this component to be used with the included mask, it must be
 * placed inside an HTML element that is relatively positioned. The
 * `.cnqr-position-relative` CSS class can be used to set relative positioning
 * on any element. For example, the **Spinner** might be inside an application’s
 * parent HTML container or inside a section on the page.
 *
 * > When using Full Page and Full Screen **Spinner** components, the top level element
 * that the spinner is overlaying must contain the attribute `inert="true"` in
 * order for content to be invisible to the accessibility tree. When the **Spinner**
 * is no longer being used to overlay any elements, `inert="false"` should
 * be set to the element which previously contained the attribute so that any
 * elements that were invisible to the accessibility tree will now be visible.
 * By using this attribute, keyboard navigation and speech output will be disabled
 * to underlying elements while **Spinner** is active and will avoid confusion to sight
 * impaired users and keyboard navigation users that inaccessible/invisible elements
 * are present on the page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/inert)
 * for more information as to how to use the `inert` attribute.
 *
 * > Note: Using the `inert` property on a Typescript React app has some issues. See examples on how
 * to pass `inert` so that the property makes it to the DOM. See this inert
 * [issue](https://github.com/WICG/inert/issues/58#issuecomment-618016847).
 */
const Spinner = exports.Spinner = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const {
      id,
      messageClassName,
      messageContainerClassName,
      size = 'md',
      visible,
      wheelClassName,
      boxClassName,
      className,
      content,
      contentClassName,
      hideMessage,
      inverted,
      maskColor = 'gray',
      message,
      type,
      statusProps
    } = props,
    otherProps = __rest(props, ["id", "messageClassName", "messageContainerClassName", "size", "visible", "wheelClassName", "boxClassName", "className", "content", "contentClassName", "hideMessage", "inverted", "maskColor", "message", "type", "statusProps"]);
  const classnames = _bind.default.bind(_Spinner.default);
  let uniqueId = (0, _useUniqueId.default)();
  if (id) {
    uniqueId = id;
  }
  const isFullPage = type === 'fullPage';
  const isFullScreen = type === 'fullScreen';
  const isFullView = isFullPage || isFullScreen;
  const isInline = type === 'inline';
  const isBlock = type === 'block';
  const _focusManagerRef = (0, _react.useRef)();
  const spinnerRef = (0, _react.useRef)(null);
  const [isMounted, setIsMounted] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    setIsMounted(true);
  }, []);
  /**
   * Note: JAWS requires an element with `role="status"` to be initially rendered on the page,
   * and then dynamically update its content in order for it to be announced.
   */
  const announcedMessage = (0, _useAnnouncedMessage.useAnnouncedMessage)({
    announce: isFullView,
    message,
    disableReset: true
  }, [visible, message, isFullView]);
  const _handleFocusManager = node => {
    if (isFullScreen && visible && node) {
      _focusManagerRef.current = new _focusManager.FocusManager({
        trapNode: node
      });
    }
  };
  const _getSpinnerSize = () => {
    if (isFullView) {
      return `${WHEEL_CSS_ELEMENT}--fullPage`;
    }
    if (isInline) {
      return `${WHEEL_CSS_ELEMENT}--inline-${size}`;
    }
    return `${WHEEL_CSS_ELEMENT}--${size}`;
  };
  const _renderSpinner = () => {
    const classNames = classnames(wheelClassName, _getSpinnerSize(), WHEEL_CSS_ELEMENT);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classNames
    }, /*#__PURE__*/_react.default.createElement("svg", {
      "aria-hidden": true,
      className: classnames(`${CSS_BLOCK}__shape`),
      viewBox: "25 25 50 50"
    }, /*#__PURE__*/_react.default.createElement("circle", {
      className: classnames(`${CSS_BLOCK}__shape--background`),
      cx: "50",
      cy: "50",
      fill: "none",
      r: "20",
      strokeMiterlimit: "10"
    }), /*#__PURE__*/_react.default.createElement("circle", {
      className: classnames(`${CSS_BLOCK}__shape--indicator`),
      cx: "50",
      cy: "50",
      fill: "none",
      r: "20",
      strokeMiterlimit: "10"
    })));
  };
  const _renderMessaging = messaging => {
    let textSize = '';
    if (isInline) {
      if (size === 'lg') {
        textSize = `${CSS_BLOCK}__message-inline--large`;
      }
    } else if (isFullView) {
      textSize = `${CSS_BLOCK}__message--large`;
    } else if (size === 'lg') {
      textSize = `${CSS_BLOCK}__message--small`;
    }
    const messageContainerClassNames = classnames(`${CSS_BLOCK}__message-box`, messageContainerClassName, {
      [`${CSS_BLOCK}__message-box--screen-reader-only`]: hideMessage
    });
    const paragraphClassNames = classnames(`${CSS_BLOCK}__message`, textSize, messageClassName, {
      [`${CSS_BLOCK}__message-inline`]: isInline
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      className: messageContainerClassNames
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: paragraphClassNames,
      id: `${uniqueId}-message`
    }, messaging));
  };
  if (!visible) {
    return null;
  }
  const classes = classnames(CSS_BLOCK, className, {
    [`${CSS_BLOCK}__mask`]: !isInline && !isBlock,
    [`${CSS_BLOCK}__mask--${maskColor}`]: !inverted && !isBlock && !isInline,
    [`${CSS_BLOCK}__mask--secondary`]: inverted,
    [`${CSS_BLOCK}__mask--full-page`]: isFullPage,
    [`${CSS_BLOCK}__mask--full-screen`]: isFullScreen,
    [`${CSS_BLOCK}--inverted`]: inverted,
    [`${CSS_BLOCK}--inline`]: isInline,
    [`${CSS_BLOCK}--block`]: isBlock
  });
  const spinnerBoxClassNames = classnames(`${CSS_BLOCK}__box`, {
    [`${CSS_BLOCK}__box--inline`]: isInline,
    [`${CSS_BLOCK}__box--centered`]: !isInline && !isBlock
  }, boxClassName);
  const spinner = /*#__PURE__*/_react.default.createElement("div", Object.assign({}, otherProps, {
    className: classes,
    ref: (0, _reactMergeRefs.default)([spinnerRef, _handleFocusManager, ref])
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: spinnerBoxClassNames
  }, _renderSpinner(), /*#__PURE__*/_react.default.createElement("span", Object.assign({}, statusProps, {
    id: uniqueId,
    role: "status",
    "aria-describedby": isInline ? undefined : `${uniqueId}-message`,
    "aria-label": isInline ? message : undefined,
    "aria-live": isFullView ? 'assertive' : 'polite',
    className: classnames(`${CSS_BLOCK}__status`, statusProps === null || statusProps === void 0 ? void 0 : statusProps.className, {
      [`${CSS_BLOCK}__message-box--screen-reader-only`]: !announcedMessage
    })
  }), announcedMessage && _renderMessaging(announcedMessage)), !announcedMessage && _renderMessaging(message), isFullScreen && content ? (/*#__PURE__*/_react.default.createElement("div", {
    className: classnames(`${CSS_BLOCK}__content`, contentClassName)
  }, content)) : null));
  return isFullScreen && isMounted ? /*#__PURE__*/_reactDom.default.createPortal(spinner, document.body, 'spinner-portal') : spinner;
});
Spinner.displayName = 'Spinner';
var _default = exports.default = Spinner;